<!--
 * @Author: weixiuting weixiuting@qq.com
 * @Date: 2022-11-22 17:03:07
 * @LastEditors: weixiuting weixiuting@qq.com
 * @LastEditTime: 2023-09-26 17:51:26
 * @FilePath: \plantingSubsidy_web\src\views\statistics-charts\insurance-statistics\components\CompanyInsurance\index.vue
 * @Description: 承保理赔一张图-统计承保统计图- 最新
-->

 <template>
  <!--  -->
  <div class="chart_box"
       id="companyInsuranceChart">

  </div>

</template>
<script>
// const labelOption = {
//   // show: true,
//   position: 'insideBottom',
//   distance: 20,
//   align: 'left',
//   verticalAlign: 'middle',
//   // rotate: 90,
//   // formatter: '{b}  {name|{a}}',
//   fontSize: 16,
//   rich: {
//     name: {}
//   }
// }
export default {
  data () {
    return {
      chart: null,
      dataset: {
        dimensions: ['companyName', '', '承保面积'],
        source: [
        //   { companyName: '保险公司1', '': 1000, '承保面积': 1000 },
        //   { companyName: '保险公司2', '': 1000, '承保面积': 800 },
        //   { companyName: '保险公司3', '': 1000, '承保面积': 600 },
        //   { companyName: '保险公司4', '': 1000, '承保面积': 500 },
        //   { companyName: '保险公司5', '': 1000, '承保面积': 900 }
        ]

      }
    }
  },
  mounted () {
    this.chart = this.$echarts.init(document.getElementById('companyInsuranceChart'))

    window.addEventListener('resize', () => {
      this.chart.resize()
    })
    this.initData()
  },
  methods: {

    initData () {
      this.initChart()
    },
    initChart () {
      let option = {
        title: {
          text: '各保险公司承保情况',
          // subtext: '(2020年5月6日)',
          top: 10,
          left: 20,
          textStyle: {
            color: '#fff',
            fontSize: 15,
            fontWeight: 'normal'

          }
        },
        grid: {
          show: false,
          top: '30%', // 一下数值可为百分比也可为具体像素值
          right: '6%',
          bottom: '13%',
          left: '10%'

        },
        tooltip: {
          trigger: 'axis',
          backgroundColor: '#103164',
          borderColor: '#2a69c6',
          textStyle: {
            color: '#c6e1fc'
            // fontSize: 14,
            // fontWeight: 'bold',
            // padding: 4
          },

          className: 'custom_tooltip_box',
          formatter: (params, a, b) => {
            let param = params.filter(i => i.componentSubType !== 'bar')

            let itemHtml = ''
            let i = 0
            let color = ['rgba(47,107,242,0.8)', 'rgba(77,152,254,0.8)', 'rgba(5,201,208,0.8)', 'rgba(66,47,242,0.8)']
            for (let key in param[0].data) {
              if (key.length >= 2 && key.length <= 7) {
                itemHtml += ` <div class="custom_tooltip_item" ><span style='display:inline-block;width:10px;height:10px;border-radius:50%;background:${color[i++]}'></span>
          <span style='padding-right:20px'>${key}</span> <span>${param[0].data[key]}万亩</span>

           </div>`
              }
            }

            return `<div class='custom_tooltip_style'>
            <div class='custom_tooltip_title'>

            ${param[0].data.companyName}

            </div>
            <div class="custom_tooltip_inner">


           ${itemHtml}
            </div>

            </div>`
          }
        },
        dataset: {
          ...this.dataset

        },
        dataZoom: [{
          // type: 'slider',
          type: 'inside',
          backgroundColor: 'rgba(47,69,84,0.4)',
          borderColor: 'rgaba(255,255,255,0.01)',
          fillerColor: 'rgba(167,183,204,0.1)',
          // show: true, // flase直接隐藏图形
          show: this.dataset.source.length > 6, // flase直接隐藏图形
          height: 3,
          xAxisIndex: [0],
          left: '9%', // 滚动条靠左侧的百分比
          bottom: '5%',
          start: 0, // 滚动条的起始位置
          end: Number((100 / (this.dataset.source.length / 6)).toFixed(0))// 滚动条的截止位置（按比例分割你的柱状图x轴长度）
          // type: 'slider',
          // show: this.dataset.source.length > 4, // flase直接隐藏图形
          // xAxisIndex: [0],
          // left: '9%', // 滚动条靠左侧的百分比
          // bottom: '5%',
          // height: 3,
          // start: 0, // 滚动条的起始位置
          // end: Number((100 / (this.dataset.source.length / 4)).toFixed(0)) - 10 // 滚动条的截止位置（按比例分割你的柱状图x轴长度）
        }],
        legend: {
          show: false,
          icon: 'rect',
          right: '3%',
          top: '18%',
          itemWidth: 10,
          itemHeight: 10,
          itemGap: 10,
          textStyle: {
            color: '#cae6fe'
          }

        },
        toolbox: {
          show: true,
          orient: 'vertical',
          left: 'right',
          top: 'center'
          // feature: {
          //   mark: { show: true },
          //   dataView: { show: true, readOnly: false },
          //   magicType: { show: true, type: ['line', 'bar', 'stack'] },
          //   restore: { show: true },
          //   saveAsImage: { show: true }
          // }
        },
        calculable: true,
        xAxis: [
          {
            type: 'category',
            axisTick: { show: false },
            position: {
              top: '10%'
            },
            /* x轴标签 */
            // axisLabel: {
            //   color: '#b0aeaf',
            //   fontSize: 12,
            //   // margin: 16
            //   rotate: 18

            // },
            axisLine: {
              lineStyle: {
                color: 'rgba(255,255,255,0.3)'
              }
            },
            axisLabel: {
              rotate: (this.dataset.source.length > 4 ? 18 : 0),
              textStyle: {
                color: '#ADADAD',
                fontSize: 12

              }

            }

          }
        ],
        yAxis: [
          {
            name: '万亩',
            nameTextStyle: {
              color: '#b0aeaf',
              fontSize: 14,
              margin: 10
            },
            fontSize: 14,
            type: 'value',

            axisLabel: {
              color: '#b0aeaf',
              fontSize: 14
              // formatter: function (value, index) {
              //   if (value > 1) {
              //     return Number((value / 10000).toFixed(1))
              //   } else return value
              // }
              // formatter: function (value, index) {
              //   if (value === 0) {
              //     return value
              //   } else if (value >= 10000) {
              //     return value / 10000 + '万亩'
              //   } else {
              //     return value + '亩'
              //   }
              // }
            },
            splitLine: {
              lineStyle: {
                color: 'rgba(255,255,255,0.3)',
                type: 'dashed'
              }
            }

          }
        ],

        color: ['rgba(255,255,255,0.05)', 'rgba(47,107,242,0.8)'],

        series: [
          // 背景柱图
          {
            name: '',
            type: 'bar',
            barMinWidth: 14,
            barWidth: 26,
            barGap: 0.2

          },
          {

            // name: '',
            showBackground: true,
            backgroundStyle: {
              color: 'rgba(255, 255, 255, 0.1)'
            },

            // type: 'pictorialBar',
            type: 'pictorialBar',
            itemStyle: {
              normal: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: 'rgba(67, 146, 253, 0.1)' },
                  { offset: 1, color: 'rgba(67, 146, 253, 1)' }
                ])
              }
            },
            symbolRepeat: 'fixed',
            symbolMargin: 3,
            symbol: 'rect',
            symbolClip: true,
            symbolSize: [16, 4],
            // symbolPosition: 'start',
            symbolOffset: [0, 1],
            emphasis: {
              focus: 'series'
            }

          }

        ]
      }
      this.chart.setOption(option, true)
      this.chart.resize()
    }
  },
  watch: {
    dataset: {

      handler (val) {
        if (val) {
          this.initData()
          console.log('重新渲染')
        }
      },
      deep: true
    }

  }
}
</script>
<style lang="less" scoped>
.chart_box {
  width: 100%;
  height: 100%;
}
/deep/.custom_tooltip_box {
  padding: 0 !important;
  border: none !important;
  background-color: transparent !important;
  height: auto !important;
  box-shadow: none !important;
  .custom_tooltip_style {
    line-height: 24px;
    padding: 4px 10px 5px;
    border: 1px solid #2a69c6;
    border-radius: 4px;
    background: #103164;
    color: #c6e1fc;
  }
  .custom_tooltip_item {
    padding-right: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/statistics-charts/insurance-statistics/components/v1/CompanyInsurance/index.vue